<template>
  <div>
    <h1 class="text-h4 mb-4">{{ pageProps.title }}</h1>

    <v-form method="post" :action="pageProps.form.action">
      <input type="hidden" name="_method" value="patch">
      <input type="hidden" name="authenticity_token" :value="pageProps.csrfToken">

      <v-card class="mb-4">
        <v-card-text>
          <v-text-field
            label="Name der Organisation"
            name="organisation[name]"
            :model-value="pageProps.organisation.name"
          />
        </v-card-text>
      </v-card>

      <v-btn color="primary" type="submit">Speichern</v-btn>
    </v-form>
  </div>
</template>

<script setup>
defineProps({
  pageProps: {
    type: Object,
    required: true,
  },
});
</script>
